import D3Locale from '@reuters-graphics/d3-locale';
import { floor10 } from 'Utils/decimalAdjust';

const numToUnits = (number, locale, e = 3) => {
  locale = locale || 'en';
  const d3Locale = new D3Locale(locale);
  const numFormat = (num) => {
    // return d3Locale.format(',')(num);
    return d3Locale.format(',')(floor10(num, -1));
  };

  const str = number < 10 ** e ? numFormat(number) :
    number < 10 ** (e * 2) ? `${numFormat(number / (10 ** e))}k` :
      number < 10 ** (e * 3) ? `${numFormat(number / (10 ** (e * 2)))}M` :
        number < 10 ** (e * 4) ? `${numFormat(number / (10 ** (e * 3)))}G` :
          `${numFormat(number / (10 ** (e * 4)))}T`;
  return str;
};

export default numToUnits;
